var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-modal',{scopedSlots:_vm._u([{key:"footer-cancel",fn:function(ref){
var close = ref.close;
return [_c('i-button',{attrs:{"size":"large"},on:{"click":function($event){return close()}}},[_vm._v(" "+_vm._s(_vm.$t('shared.component.button.close'))+" ")])]}}])},[_c('z-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"show_pagination_description":false,"show_header":false,"show_per_page":false},scopedSlots:_vm._u([{key:"status",fn:function(ref){
var item = ref.item;
return [_c('state-badge',{attrs:{"value":item.status}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }